// Secvia VPN Configuration
// Измените эти значения для настройки сайта

export const CONFIG = {
  // Ссылка на Google Play - ИЗМЕНИТЕ ЭТУ ССЫЛКУ ПЕРЕД РЕЛИЗОМ
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=app.secvia.vpn',
  
  // Email поддержки
  supportEmail: 'support@secvia.app',
  
  // Домен сайта
  domain: 'secvia.app',
  
  // Логотипы
  logos: {
    light: 'https://customer-assets.emergentagent.com/job_vpnapp-preview/artifacts/jjofnagh_logo-light.png',
    dark: 'https://customer-assets.emergentagent.com/job_vpnapp-preview/artifacts/0rkivrv6_logo-dark.png',
    icon: 'https://customer-assets.emergentagent.com/job_vpnapp-preview/artifacts/twb8n6l8_logo-icon.png'
  },
  
  // Цены (информационные)
  pricing: {
    month1: { price: '$4.99', period: '1' },
    month6: { price: '$23.99', period: '6' },
    year1: { price: '$39.99', period: '12' }
  },
  
  // Язык по умолчанию
  defaultLanguage: 'ru',
  
  // Доступные языки
  availableLanguages: ['ru', 'ua', 'en']
};
